<template>
  <div>
    <div class="page-title">{{pageTitle}}</div>
    <div class="page-header">
      <page-tab
        :tabs="tabs"
        :nowTab="nowTab"
        :isParams="true"
        :paramsLabel="'type'"></page-tab>
      <filter-com ref="filterCom"
        @filterConSearch="confirmFilter"
        @toggleFilterShow="toggleFilterShow"></filter-com>
    </div>
    <div class="page-content">
      <div class="page-table-addon">
        <div class="table-data-count">共<span>{{tableDataCount}}</span>条数据</div>
        <div class="table-ope">
          <template v-if="nowTab !== '6'">
            <div class="table-all-rename link-btn" @click.stop="toggleAllRenameDiag(true)">
              <i class="yjh-icon icon-all-rename"></i>批量别名
            </div>
            <div class="table-all-del link-btn" @click.stop="delArr(selArr, 'all')">
              <i class="yjh-icon icon-all-del"></i>批量删除
            </div>
            <div class="table-add-lib link-btn" @click.stop="gotoPage('addLib')">
              <i class="yjh-icon icon-add-lib"></i>新增主数据
            </div>
          </template>
          <template v-else>
            <div class="table-restore link-btn" @click.stop="restoreArr(selArr, 'all')">
              <i class="yjh-icon icon-restore"></i>批量还原
            </div>
          </template>
        </div>
      </div>
      <page-table
        ref="table"
        v-loading="tableLoading"
        :loading="tableLoading"
        :col="tableCol"
        :data="tableData"
        :pageSize="pageSize"
        :pageIndex="pageIndex"
        :total="tableDataCount"
        :selectAll="selectAll"
        :selectChange="selectChange"
        @compFn="compFn"
        @pageChange="pageChange"
        @pageSizeChange="pageSizeChange"
      ></page-table>
    </div>
    <!-- 批量别名弹框 -->
    <all-rename-diag
      :isShow="allRenameDiag"
      :uploadaction="uploadaction"
      @close="toggleAllRenameDiag(false)"
    ></all-rename-diag>
    <!-- 删除弹框 -->
    <simple-diag
      :isShow="delDiag"
      :title="delTitle"
      :width="'400px'"
      :htm="false"
      @confirm="confirmDel"
      @close="toggleDelDiag(false)">
      <template v-if="delType === 'one'">
        <div class="simple-diag-text">确定删除 <span class="blue">{{delName}}</span> 吗？</div>
      </template>
      <template v-else>
        <div class="simple-diag-text">确定删除吗？</div>
      </template>
    </simple-diag>
  </div>
</template>
<script>
import Vue from 'vue'
import pageTab from '@/components/pageCom/pageTab'
import pageTable from '@/components/pageCom/pageTable'
import filterCom from './components/filtersCom'
import allRenameDiag from './components/allRenameDiag'
import simpleDiag from '@/components/dialogs/simpleDiag'
import { msg } from '@/utils'
import { statndSearchOptions, standGetList, standUserDelete, standRecycleBack } from '@/api/content'

export default {
  name: 'standardLib',
  components: { pageTab, pageTable, filterCom, allRenameDiag, simpleDiag },
  data() {
    return {
      uploadaction: process.env.VUE_APP_BASE_API + '/standard/user_import',
      tabs: [
        {
          text: '主数据汇总',
          num: '102000',
          linkName: '1'
        }, {
          text: '医院',
          num: '2000',
          linkName: '2'
        }, {
          text: '药店',
          num: '690',
          linkName: '3'
        }, {
          text: '商业公司',
          num: '2000',
          linkName: '4'
        }, {
          text: '第三终端',
          num: '7000',
          linkName: '5'
        }, {
          text: '回收站',
          num: '677',
          linkName: '6'
        }
      ],
      fields: [], // 字段列表(子组件filel搜索的下拉选项)
      searchParams: '', // 保存子组件搜索传递过来的filterList
      curTableId: '', // 当前的tableid
      curRuleId: '', // 当前的ruleid
      tableLoading: false, // 表格loading
      pageSize: 30, // 单页数据个数
      pageIndex: 1, // 当前页
      tableDataCount: 0, // 表格总数据
      tableCol: [], // 表格数据
      tableData: [], // 表格数据
      allRenameDiag: false, // 批量别名弹框
      delDiag: false, // 删除弹框
      selArr: [], // 选中的条目
      delId: '', // 单独删除需要的id
      delType: 'one', // 单独删除还是批量删除
      delName: '',
      delTitle: '删除提示'
    }
  },
  computed: {
    nowTab() {
      return this.tabs[Number(this.$route.params.type) - 1].linkName
    },
    pageTitle() {
      return this.tabs[Number(this.$route.params.type) - 1].text
    }
  },
  mounted() {
    this.init()
    this.initCol()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    // 初始化
    init() {
      this.initPagination() // 回复分页器和表格数据
      this.$nextTick(() => {
        this.$refs.filterCom.init() // mounted watch 选择组件的选择内容会被清空
        this.getFields() // 获取下拉框的数据
        this.getTableData()
      })
    },
    initCol() {
      this.tableCol = [
        { width: 60, type: 'selection', titleAlign: 'left', columnAlign: 'left' },
        { field: 'operate', title: '操作', width: 100, titleAlign: 'left', columnAlign: 'left', componentName: 'libOpe' },
        { field: 'id', title: '编号', width: 60, titleAlign: 'left', columnAlign: 'left' },
        { field: 'flag', title: '标识', width: 60, titleAlign: 'left', columnAlign: 'left' },
        { field: 'source', title: '来源', width: 60, titleAlign: 'left', columnAlign: 'left' },
        { field: 'name', title: '名称', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'usedName', title: '曾用名', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'otherNames', title: '别名', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'province', title: '省', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'city', title: '市', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'district', title: '区、县', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'address', title: '地址', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'yjhLevel', title: '药聚汇-等级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'weijiweiLevel', title: '卫计委-等级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'weiyiLevel', title: '微医-等级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'chunyuLevel', title: '春雨医生-等级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'haodaifeLevel', title: '好大夫-等级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'info', title: '医院简介', width: 220, titleAlign: 'left', columnAlign: 'left' },
        { field: 'phone', title: '电话', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'lang', title: '经度', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'lat', title: '纬度', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'class', title: '终端分类', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'type', title: '终端类型', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'leibie', title: '终端类别', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'xingzhi', title: '经营性质', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'suoyouzhi', title: '所有制形式', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'dingji', title: '定级', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'dingdeng', title: '定等', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'lincense', title: '营业执照', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'startDate', title: '成立日期', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'yDate', title: '营业期限', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'yStatus', title: '经营状态', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'website', title: '官网地址', width: 220, titleAlign: 'left', columnAlign: 'left' }
      ]
    },
    initPagination() {
      this.pageIndex = 1
      this.pageSize = 30
      this.tableDataCount = 0
      this.tableData = []
    },
    // 获取当表的字段列表
    getFields() {
      statndSearchOptions({ servicetype: this.$route.params.type })
        .then(res => {
          if (res.code === 0) {
            this.fields = res.result.select1
          } else {
            msg.call(this, '获取下拉选项数据失败')
            this.fields = []
          }
        })
    },
    // 筛选条件
    confirmFilter(filters) { // 子组件的搜索
      this.initPagination() // 初始化表格和分页数据
      this.searchParams = this.resetSearchParams(filters)
      // this.getTableData() 调用搜索接口
    },
    resetSearchParams(filters) { // 子组件传递过来的数据需要处理
      const arr = filters.map(item => {
        if (item.fieldType === '3') {
          if (item.aggr === '50' || item.arrg === '60') {
            return { create_name: item.field, filter_type: item.aggr, value: '' }
          } else {
            return { create_name: item.field, filter_type: item.aggr, value: item.value }
          }
        } else {
          return { create_name: item.field, filter_type: item.aggr, value: item.value }
        }
      })
      return arr
    },
    // 筛选展开
    toggleFilterShow() {
      this.$refs.table.resize()
    },
    // 获取表格数据
    getTableData() {
      this.tableLoading = true
      const params = {
        servicetype: this.$route.params.type,
        currentpage: this.pageIndex,
        rp: this.pageSize,
        filter: ''
      }
      standGetList(params).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.list
          this.tableDataCount = result.total_num
        } else {
          msg.call(this, '获取数据失败')
          this.tableData = []
          this.tableDataCount = 0
        }
      })
    },
    // 去页面
    gotoPage(name) {
      this.$router.push({
        name: name,
        params: {
          type: this.$route.params.type
        }
      })
    },
    // 批量别名，开弹框
    toggleAllRenameDiag(flag) {
      this.allRenameDiag = flag
    },
    // 批量还原
    restoreArr(arr, state) {
      if (state === 'all' && !arr.length) {
        this.$Message.info('请选择要操作的数据项！')
        return ''
      }
      const ids = state === 'all'
        ? arr.map(item => item.id).join(',')
        : arr.join(',')
      standRecycleBack({ ids: ids }).then(res => {
        const { code, msg } = res
        if (code === 0) {
          if (this.pageIndex > 1 && this.tableData.length === arr.length) {
            this.pageIndex -= 1
            this.getTableData()
          }
        } else {
          this.$Message.info(msg)
        }
      })
    },
    // 删除
    delArr(arr, flag) {
      this.delType = flag
      if (flag === 'one') {
        this.delTitle = '删除提示'
        this.delName = this.tableData[arr[0]].name
        this.delId = this.tableData[arr[0]].id
      } else {
        if (!arr.length) {
          msg.call(this, '请选择要操作的数据项！')
          return
        }
        this.delTitle = '批量删除'
      }
      this.toggleDelDiag(true)
    },
    // 删除弹框
    toggleDelDiag(flag) {
      this.delDiag = flag
    },
    confirmDel() {
      if (this.delType === 'one') { // 单数删除
        standUserDelete({ ids: this.delId }).then(res => {
          if (res.code === 0) {
            this.toggleDelDiag(false)
            if (this.pageIndex > 1 && this.tableData.length === 1) {
              this.pageIndex -= 1
            }
            this.getTableData()
          } else {
            msg.call(this, '删除失败！')
          }
        })
      } else {
        standUserDelete({
          ids: this.selArr.map(item => item.id).join(',')
        }).then(res => {
          if (res.code === 0) {
            this.toggleDelDiag(false)
            if (this.pageIndex > 1 && this.selArr.length === this.tableData.length) {
              this.pageIndex -= 1
            }
            this.getTableData()
          } else {
            msg.call(this, '删除失败！')
          }
        })
      }
    },
    // 不确定选中
    selectAll(selection) {
      this.selArr = selection
      if (this.disableSel) {
        this.$refs.table.clearSelect()
      }
    },
    // 不确定选中
    selectChange(selection, rowData) {
      this.selArr = selection
    },
    // 表格事件
    compFn(params) {
      if (params.type === 'del') {
        // 删除
        this.delArr([params.index], 'one')
      } else if (params.type === 'restore') {
        // 还原
        this.restoreArr([params.index], 'one')
      }
    },
    pageChange(page) {
      this.pageIndex = page
      this.getTableData()
    },
    pageSizeChange(size) {
      this.pageIndex = 1
      this.pageSize = size
      this.getTableData()
    }
  }
}

// 自定义列组件
Vue.component('libOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  computed: {
    pageType() {
      return this.$route.params.type
    }
  },
  methods: {
    edit() {
      this.$router.push({
        name: 'editLib',
        params: {
          type: this.$route.params.type,
          id: this.rowData.id
        }
      })
    },
    del() {
      this.$emit('on-custom-comp', {
        type: 'del',
        index: this.index
      })
    },
    restore() {
      this.$emit('on-custom-comp', {
        type: 'restore',
        index: this.rowData.id
      })
    }
  },
  render: function(h) {
    if (this.pageType !== '6') {
      return h('div', {
        class: 'operate'
      }, [
        h('span', {
          class: 'link-btn',
          on: {
            click: this.edit
          }
        }, '编辑'),
        h('span', {
          class: 'link-btn link-btn-red',
          on: {
            click: this.del
          }
        }, '删除')
      ])
    } else {
      return h('span', {
        class: 'link-btn',
        on: {
          click: this.restore
        }
      }, '还原')
    }
  }
})
</script>
<style lang="scss" scoped="">
</style>
